
















































































import { Component, Emit, Prop, Vue } from 'vue-property-decorator';
import { uuid } from '@/util/uuid';
@Component({
  components: {},
})
export default class ContactsInput extends Vue {
  @Prop(Number) unitId: any;
  private dataText: any = '123123';
  private drawer = false;

  @Prop() private formProp: any;
  @Prop() private formAll: any;

  private form: any = {};

  mounted() {
    if (JSON.stringify(this.formProp) == '{}') {
      this.form = {
        id: uuid(),
        label: '设备标准卡',
        placeholder: '请选择',
        required: true,
        linkFacilityControlId: '',
        value: {
          facilityId: null,
          facilityIntegrityLevel: 'subHealth',
          facilityCriterionClausesIds: null,
        },
        // option: '1',
        // scan: false,
      };
      this.$nextTick(() => {
        this.$emit('unit_set_data', { id: this.unitId, form: this.form });
      });
    } else {
      this.formProp.placeholder || (this.formProp.placeholder = '请选择');
      this.form = this.formProp;
    }
    console.log(this.form);
  }

  closeTap() {
    console.log(this.unitId);
    this.$emit('i_close', { id: this.unitId });
  }

  beforeClose(done: any) {
    console.log(this.formAll);
    console.log(this.form);
    this.$emit('unit_set_data', { id: this.unitId, form: this.form });
    done();
  }
}
